const RESOURCE_NAME = '/video-status';
const RESOURCE__NAME = '/video-statuses';

export default axios => ({
    getAll(params) {
        return axios.get(`/units${RESOURCE__NAME}`, {params});
    },
    forGroup(id, params) {
        return axios.get(`/unit-groups/${id}${RESOURCE__NAME}`, {params});
    },
    forUnit(id, params) {
        return axios.get(`/units/${id}${RESOURCE_NAME}`, {params});
    },
});